// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2wSji","errorLogs":"styles_errorLogs__3YMH3"};